"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = renderMediaItem;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _GatsbyImage = _interopRequireDefault(require("../components/GatsbyImage"));

var _templateObject;

function renderMediaItem(mediaItem) {
  var thumbnail = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var el = null;

  if (mediaItem.type === 'image' && mediaItem.subtype === 'svg+xml') {
    el = /*#__PURE__*/_react.default.createElement("img", {
      className: "jam-cms-svg",
      src: mediaItem.sourceUrl
    });
  } else if (mediaItem.type === 'image') {
    el = /*#__PURE__*/_react.default.createElement(_GatsbyImage.default, {
      image: mediaItem,
      objectFit: "contain",
      alt: mediaItem.alt
    });
  } else if (mediaItem.type === 'application') {
    el = /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("img", {
      className: "jam-cms-placeholder-icon",
      src: mediaItem.icon
    }), /*#__PURE__*/_react.default.createElement("span", null, mediaItem.title));
  } else if (mediaItem.type === 'video') {
    if (thumbnail) {
      el = /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("img", {
        className: "jam-cms-placeholder-icon",
        src: mediaItem.icon
      }), /*#__PURE__*/_react.default.createElement("span", null, mediaItem.title));
    } else {
      el = /*#__PURE__*/_react.default.createElement("video", {
        controls: true
      }, /*#__PURE__*/_react.default.createElement("source", {
        src: mediaItem.url,
        type: mediaItem.mime_type
      }));
    }
  }

  return /*#__PURE__*/_react.default.createElement(Container, null, el);
}

var Container = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n\n  .jam-cms-svg {\n    max-height: 100%;\n    max-width: 100%;\n  }\n\n  .jam-cms-placeholder-icon {\n    width: 30px;\n    margin: 0 auto 10px;\n  }\n\n  .gatsby-image-wrapper {\n    max-height: 100%;\n    max-width: 100%;\n  }\n\n  span {\n    display: block;\n    width: 100%;\n    text-align: center;\n    font-size: 14px;\n  }\n"])));